<span class="font-semibold text-lg my-4">Delivery Details</span>
<sbd-account-portal-frontend-drawer-content-wrapper
     class="mb-2"
      *ngFor="let key of Object.keys(activeOpenedQR);let j = index;"
                                                    [title]="key"
                                                    (selectedShippingMethodID)="getShippingMethodValue($event, key,j)">

  <div class="px-2 rounded-2xl mt-2 text-md sm:text-sm" *ngFor="let openQR of activeOpenedQR[key]">
    <sbd-account-portal-frontend-accordion-content
      [item]="openQR"
      [toggleAccordion]="queuedQR.length === 1"
      (updatedOpenQR)="updateSelectedQuoteOption($event)">
    </sbd-account-portal-frontend-accordion-content>
  </div>
</sbd-account-portal-frontend-drawer-content-wrapper>
